import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Option } from './ColorOption.styles';
export const ColorOption = /*#__PURE__*/ forwardRef(({ className, color, isDisabled = false, isSelected = false, name, onChange, onKeyDown, textContent }, ref)=>{
    const handleChangeEvent = (event)=>{
        event.preventDefault();
        if (isDisabled || isSelected) {
            return;
        }
        onChange(color);
    };
    return /*#__PURE__*/ _jsx(Option, {
        "aria-label": textContent,
        checked: isSelected,
        className: className,
        color: color,
        disabled: isDisabled,
        name: name,
        onChange: handleChangeEvent,
        onClick: handleChangeEvent,
        onFocus: handleChangeEvent,
        onKeyDown: onKeyDown,
        ref: ref,
        title: textContent,
        type: "radio",
        value: color
    });
});

//# sourceMappingURL=ColorOption.js.map